import { GetAllContentsInDto, GetAllContentsOutDto } from '../../../types/content.dto'

export const GET_ALL_CONTENTS = 'GET_ALL_CONTENTS'
export const GET_ALL_CONTENTS_SUCCESS = 'GET_ALL_CONTENTS_SUCCESS'
export const GET_ALL_CONTENTS_ERROR = 'GET_ALL_CONTENTS_ERROR'
export const RESET_GET_ALL_CONTENTS = 'RESET_GET_ALL_CONTENTS'
export const UPDATE_CONTENTS = 'UPDATE_CONTENTS'

export interface GetAllContents {
  type: typeof GET_ALL_CONTENTS
  payload: GetAllContentsOutDto
}

export interface GetAllContentsSuccess {
  type: typeof GET_ALL_CONTENTS_SUCCESS
  payload: GetAllContentsInDto
}

export interface GetAllContentsError {
  type: typeof GET_ALL_CONTENTS_ERROR
  payload: string | boolean
}

export interface ResetGetAllContents {
  type: typeof RESET_GET_ALL_CONTENTS
  payload: null
}

export interface UpdateContents {
  type: typeof UPDATE_CONTENTS
  payload: GetAllContentsInDto
}

export interface State {
  data: GetAllContentsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllContents
  | GetAllContentsSuccess
  | GetAllContentsError
  | ResetGetAllContents
  | UpdateContents
